import { restoreSavedLogin } from './native/app';

// In the phone app the sign-in is also kept in the phone's own storage (the
// web view's storage can be lost when Android closes the app). Put it back
// before the store reads it, then start the app.
restoreSavedLogin().finally(() => import('./boot'));
